import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import TextField from '../fields/TextField';
import useExtendedMutation from '../../hooks/useExtendedMutation';
import { ALL_MESSAGES_QUERY_NAME, CREATE_MESSAGE } from '../../graphql/messages';
import SaveButton from '../buttons/SaveButton';
import useExtendedState from '../../hooks/useExtendedState';
import { MESSAGE_MAX_LENGTH, messageValidator } from '../../validators/messages';
import ExpandedListTab from '../ExpandedListTab';
import useSingleValidator from '../../hooks/useSingleValidator';
import { compositeValidator, wafValidator } from '../../hooks/validationSupport';

MessageCreateTab.propTypes = {
    hideHandler: PropTypes.func.isRequired,
};

function MessageCreateTab(props) {
    const {
        hideHandler,
    } = props;
    const { t } = useTranslation();
    const messageState = useExtendedState('');
    const { validator, isValid } = useSingleValidator(false, useMemo(() => compositeValidator(messageValidator(t), wafValidator(t)), [t]));
    const [isDisabled, setIsDisabled] = useState(true);
    isValid()
        .then(() => setIsDisabled(false))
        .catch(() => setIsDisabled(true));

    const extendedMutation = useExtendedMutation(CREATE_MESSAGE, {
        variables: { message: messageState.value },
        successCallback: hideHandler,
        successMessageOptions: { key: 'messages.notification.message-create-success', dataProperty: 'createMessage' },
        failureMessageOptions: { key: 'messages.notification.message-create-failure', params: { message: messageState.value } },
        refetchQueries: [ALL_MESSAGES_QUERY_NAME],
    });
    return (
        <ExpandedListTab
            className="message-create-tab"
            title={t('messages.message-detail')}
        >
            <div className="rich-list-row-expanded--fields">
                <TextField
                    label={t('messages.message')}
                    state={messageState}
                    className="message-create-tab--fields--message xx-wide"
                    validator={validator}
                    placeholder={t('messages.placeholder.message')}
                    maxLength={MESSAGE_MAX_LENGTH}
                    isRequired
                />
            </div>
            <div className="rich-list-row-expanded--buttons">
                <SaveButton
                    extendedMutation={extendedMutation}
                    disabled={isDisabled}
                    confirmationMessage={t('messages.confirm-create-message', { message: messageState.value })}
                    label={t('button.send')}
                    icon="share"
                />
            </div>
        </ExpandedListTab>
    );
}

export default MessageCreateTab;
